import React from 'react';
import { PlusCircle, Edit, Trash2, ArrowLeft } from 'lucide-react';
import { getLevelStyling } from '../utils/roadmapStylingHelper';

const RoadmapSessionsList = ({
  selectedLevel,
  setSelectedLevel,
  handleEditSession,
  handleDeleteSession,
  setShowAddSessionModal,
}) => {
  const { color } = getLevelStyling(selectedLevel.order); // Get dynamic color for level header

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h2 className={`text-3xl font-bold bg-gradient-to-r ${color} bg-clip-text text-transparent`}>
          Sessions for {selectedLevel.name}
        </h2>
        <div className="flex gap-3">
          <button
            onClick={() => setSelectedLevel(null)}
            className="flex items-center gap-2 px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm font-medium transition-colors"
          >
            <ArrowLeft className="w-5 h-5" /> Back to Levels
          </button>
          <button
            onClick={() => setShowAddSessionModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-600 to-teal-600 hover:from-green-700 hover:to-teal-700 rounded-lg text-sm font-medium transition-colors"
          >
            <PlusCircle className="w-5 h-5" /> Add New Session
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {selectedLevel.items.length === 0 ? (
          <div className="text-center py-12 text-slate-500">
            <p>No sessions defined for this level yet. Add one!</p>
          </div>
        ) : (
          selectedLevel.items.map((session) => (
            <div
              key={session.id}
              className="bg-slate-800 rounded-xl p-6 border border-slate-700 hover:border-slate-600 transition-colors flex justify-between items-start"
            >
              <div className="flex items-center space-x-4">
                <div className="w-10 h-10 bg-slate-700 rounded-full flex items-center justify-center text-white font-bold text-md">
                  {session.order}
                </div>
                <div>
                  <h3 className="text-start text-lg font-semibold text-white">{session.title}</h3>
                  <p dangerouslySetInnerHTML={{__html: session.description}} className="text-start text-slate-400 text-sm" />
                  <div className="flex items-center gap-4 mt-2 text-xs text-slate-500">
                    <span className="px-2 py-1 bg-slate-700 rounded-full">{session.type || 'Technical'}</span>
                    {session.dueDate && <span>Due: {session.dueDate}</span>}
                    {session.estimatedHours && <span>Est. Hours: {session.estimatedHours}</span>}
                  </div>
                </div>
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleEditSession(session)}
                  className="p-2 text-yellow-400 hover:text-yellow-200 hover:bg-slate-700 rounded-lg transition-colors"
                >
                  <Edit className="w-5 h-5" />
                </button>
                <button
                  onClick={() => handleDeleteSession(session.id)}
                  className="p-2 text-red-400 hover:text-red-200 hover:bg-slate-700 rounded-lg transition-colors"
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default RoadmapSessionsList;